import React from "react";
import { BrowserRouter } from "react-router-dom";
import { App } from "@src/App";
import { store } from "@src/services/state/store";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";

dayjs.extend(utc);

const container = document.getElementById("root");
const root = createRoot(container!);

// Render the app immediately - authentication and API initialization
// will be handled inside App.tsx after checking for stored JWT tokens
const Index = (
  <BrowserRouter>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </BrowserRouter>
);

root.render(Index);
